import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useOneFrontStore } from "../../service-state";
import { useShallow } from "zustand/react/shallow";

export const NavigationEventHandler = () => {
  const navigate = useNavigate();

  const { loadFromQueryString } = useOneFrontStore(
    useShallow((state) => ({
      loadFromQueryString: state.loadFromQueryString
    }))
  );

  useEffect(() => {
    const parseEvent = (event) => {
      if (typeof event.data !== "string") {
        // Ignore non-string messages
        return null;
      }

      try {
        return JSON.parse(event.data);
      } catch (e) {
        return null;
      }
    };

    const extractNavigationRoute = (url) => {
      if (url?.length > 0) {
        return url.substring(url.indexOf("://") + 3);
      }
      return null;
    };

    const eventHandler = (event) => {
      const data = parseEvent(event);
      if (data === null) {
        return;
      }

      switch (data.type) {
        case "navigation":
          const urlToNavigate = extractNavigationRoute(data.navigate);
          navigate(urlToNavigate);
        case "update":
          if (data.ctx) {
            try {
              loadFromQueryString(data.ctx);
            } catch (error) {
              console.error("Couldn't update session", error);
            }
          }
          break;
        default:
          break;
      }
    };

    addEventListener("message", eventHandler);

    return function cleanup() {
      removeEventListener("message", eventHandler);
    };
  });

  return null;
};
